import { encore } from '@saucelabs/sl-util-axios';


export const getDownloadLinks = () => (
  encore.get('/versions.json')
);
